import { useQuery } from 'data-fetching-client';
import { GET_LISTING_DETAILS_V1_QUERY as GET_LISTING_DETAILS_V1_QUERY_PUBLIC } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc.dfc.new';
import { GET_LISTING_DETAILS_V1_QUERY as GET_LISTING_DETAILS_V1_QUERY_IN_APP } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc-app.dfc.new';
// All consumers should use the centralized useUnifiedDetails hook
// which will stay up to date with the various version bumps
// until things stabilize for release
export function useUnifiedDetailsV1({
  appContext,
  slug,
  language,
  skip
}) {
  var _unifiedDetailsData$r, _previousUnifiedDetai;
  const variables = slug ? language ? {
    slug,
    language
  } : {
    slug
  } : undefined;
  const {
    data: unifiedDetailsDataInApp,
    previousData: previousUnifiedDetailsDataInApp,
    loading: unifiedDetailsLoadingInApp,
    error: unifiedDetailsErrorInApp
  } = useQuery(GET_LISTING_DETAILS_V1_QUERY_IN_APP, {
    variables,
    skip: skip || !slug || appContext !== 'app'
  });
  const {
    data: unifiedDetailsDataPublic,
    previousData: previousUnifiedDetailsDataPublic,
    loading: unifiedDetailsLoadingPublic,
    error: unifiedDetailsErrorPublic
  } = useQuery(GET_LISTING_DETAILS_V1_QUERY_PUBLIC, {
    variables,
    skip: skip || !slug || appContext !== 'public'
  });
  const unifiedDetailsData = appContext === 'app' ? unifiedDetailsDataInApp : unifiedDetailsDataPublic;
  const previousUnifiedDetailsData = appContext === 'app' ? previousUnifiedDetailsDataInApp : previousUnifiedDetailsDataPublic;
  const parsedUnifiedDetailsData = JSON.parse((unifiedDetailsData === null || unifiedDetailsData === void 0 || (_unifiedDetailsData$r = unifiedDetailsData.result) === null || _unifiedDetailsData$r === void 0 ? void 0 : _unifiedDetailsData$r.listing) || '{}');
  const parsedPreviousUnifiedDetailsData = JSON.parse((previousUnifiedDetailsData === null || previousUnifiedDetailsData === void 0 || (_previousUnifiedDetai = previousUnifiedDetailsData.result) === null || _previousUnifiedDetai === void 0 ? void 0 : _previousUnifiedDetai.listing) || '{}');
  return {
    unifiedDetailsData: parsedUnifiedDetailsData,
    previousUnifiedDetailsData: parsedPreviousUnifiedDetailsData,
    unifiedDetailsLoading: appContext === 'app' ? unifiedDetailsLoadingInApp : unifiedDetailsLoadingPublic,
    unifiedDetailsError: appContext === 'app' ? unifiedDetailsErrorInApp : unifiedDetailsErrorPublic
  };
}